<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/01.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/02.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/03.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/04.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/05.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/06.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/07.jpg" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/ecom-6-720x720-1.webp" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/ecom-7-600x720-1.webp" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case6">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/ecommerce/ecom-8-720x720-1.webp" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>